import { c as _c } from "react/compiler-runtime";
import { origin } from '@/globals/config/origin.config';
import { translateInline } from '@/globals/translate/translateInline';
import { emailIcon } from '@/uiIcons/emailIcon.css';
import { externalLinkIcon } from '@/uiIcons/externalLinkIcon.css';
import { iconInline } from '@/uiPrimitives/media/iconInline';
const getIconInfo = (href: string) => {
  let hrefURL: URL;
  let originURL: URL;
  try {
    hrefURL = new URL(href, origin);
    originURL = new URL(origin);
  } catch (_error) {
    return undefined;
  }
  if (hrefURL.protocol === 'mailto:') {
    return {
      iconName: emailIcon,
      label: translateInline({
        en: 'Email',
        nl: 'E-mail'
      })
    };
  }
  if (hrefURL.protocol !== 'http:' && hrefURL.protocol !== 'https:') {
    return undefined;
  }
  if (hrefURL.origin !== originURL.origin) {
    return {
      iconName: externalLinkIcon,
      label: translateInline({
        en: 'External link',
        nl: 'Externe link'
      })
    };
  }
  return undefined;
};

/**
 * This has to be `display: inline;` otherwise line breaks will be messed up
 */
export const LinkKindIconInline = t0 => {
  const $ = _c(9);
  const {
    href
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== href) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const iconInfo = getIconInfo(href);
      if (iconInfo == null) {
        t4 = null;
        break bb0;
      }
      const {
        iconName,
        label
      } = iconInfo;
      t1 = "img";
      t2 = label;
      t3 = iconInline({
        icon: iconName
      });
    }
    $[0] = href;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t5 = <i role={t1} aria-label={t2} className={t3} />;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};